<script>
import RadioGroup from '@/components/pc/radio/ipradio/atoms/RadioGroup.vue'
import RangeSlider from '@/components/pc/radio/ipradio/atoms/RangeSlider.vue'
import SelectBox from '@/components/pc/radio/ipradio/atoms/SelectBox.vue'
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC, BC_TRANS_JP } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'

export default {
  components: {
    RadioGroup,
    RangeSlider,
    SelectBox,
    ToggleSwitch,
    SettingGroup,
    SettingItem
  },

  data() {
    // ========== 静的変数 ==========
    const radioBtnOptions = {
      rolloverEndStop: Object.keys(BC.OPTIONAL_FEATURES.DISPLAY.ROLLOVER_END_STOP).map((key) => {
        return {
          label: BC_TRANS_JP.OPTIONAL_FEATURES.DISPLAY.ROLLOVER_END_STOP[key],
          value: BC.OPTIONAL_FEATURES.DISPLAY.ROLLOVER_END_STOP[key],
        }
      }),
      backlight: Object.keys(BC.OPTIONAL_FEATURES.DISPLAY.BACKLIGHT)
        .filter((key) => {
          return key !== 'DISABLE'
        })
        .map((key) => {
          return {
            label: BC_TRANS_JP.OPTIONAL_FEATURES.DISPLAY.BACKLIGHT[key],
            value: BC.OPTIONAL_FEATURES.DISPLAY.BACKLIGHT[key],
          }
        }),
    }

    const selectboxOptions = {
      backlightTimer: BC.OPTIONAL_FEATURES.DISPLAY.BACKLIGHT_TIMER.map((value) => {
        return {
          label: `${value}秒`,
          value: String(value),
        }
      }),
    }

    return {
      radioBtnOptions,
      selectboxOptions,

      radioSettings: null,

      // ========== リアクティブ変数 ==========
      form: {
        radioBtn: {
          rolloverEndStop: radioBtnOptions.rolloverEndStop[0].value,
          backlight: radioBtnOptions.backlight[0].value,
        },
        selectbox: {
          backlightTimer: selectboxOptions.backlightTimer[0].value,
        },
        toggle: {
          backlight: false,
          modeResetTimer: false,
          doubleHeightMenuDisplay: false,
          busyLed: false,
          transmitLed: false,
        },
        range: {
          modeResetTimerValue: 0,
        },
      },

      setting: null
    }
  },

    computed: {
       BC() {
           return BC
       }
    },

  watch: {
    form: {
      handler() {
        // フォームの内容を端末設定データに変換して反映
        this.transForm2Setting()
        // 最新の状態をストアの仮保存端末設定情報にも適用
        this.radioSettings.saveTempSetting(this.setting)
      },
      deep: true
    }
  },

    created() {
        // ストアに仮保存済みの端末設定情報を取得する
        this.radioSettings = useRadioSettingsStore()
        this.setting = this.radioSettings.getTempSetting()

        this.transSetting2Form()
  },

  methods: {
    // ========== methods ==========
    transForm2Setting() {
      const data = this.setting.OptionalFeatures.Display

      console.log('============================')
      console.log('before setting: ', JSON.parse(JSON.stringify(this.setting.OptionalFeatures.Display)))

      data.Rollover_EndStop = this.form.radioBtn.rolloverEndStop
      data.Backlight = this.form.toggle.backlight
        ? this.form.radioBtn.backlight
        : BC.COMMON.TOGGLE.DISABLE
      data.BacklightTimer = this.form.selectbox.backlightTimer
      data.ModeResetTimer = this.form.toggle.modeResetTimer
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
      data.ModeResetTimerValue = this.form.range.modeResetTimerValue
      data.DoubleHeightMenuDisplay = this.form.toggle.doubleHeightMenuDisplay
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
      data.LEDs.BusyLED = this.form.toggle.busyLed ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE
      data.LEDs.TransmitLED = this.form.toggle.transmitLed
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      console.log('after setting: ', JSON.parse(JSON.stringify(this.setting.OptionalFeatures.Display)))
    },

    transSetting2Form() {
      const data = this.setting.OptionalFeatures.Display

      console.log('============================')
      console.log('before form: ', JSON.parse(JSON.stringify(this.form)))

      console.log(data.Rollover_EndStop)
      this.form.radioBtn.rolloverEndStop = data.Rollover_EndStop
      this.form.toggle.backlight = data.Backlight !== BC.COMMON.TOGGLE.DISABLE
      this.form.radioBtn.backlight =
        data.Backlight !== BC.COMMON.TOGGLE.DISABLE
          ? data.Backlight
          : BC.OPTIONAL_FEATURES.DISPLAY.BACKLIGHT.KEY_OPERATION
      this.form.selectbox.backlightTimer = data.BacklightTimer
      this.form.toggle.modeResetTimer = data.ModeResetTimer === BC.COMMON.TOGGLE.ENABLE
      this.form.range.modeResetTimerValue = data.ModeResetTimerValue
      this.form.toggle.doubleHeightMenuDisplay =
        data.DoubleHeightMenuDisplay === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.busyLed = data.LEDs.BusyLED === BC.COMMON.TOGGLE.ENABLE
      this.form.toggle.transmitLed = data.LEDs.TransmitLED === BC.COMMON.TOGGLE.ENABLE

      console.log('after form: ', JSON.parse(JSON.stringify(this.form)))
    },

    handleSelect(value) {
      this.form.selectbox.backlightTimer = Number(value)
    }
  }
}
</script>

<template>
    <div>
        <SettingGroup>
            <SettingItem label="グループの遷移方法">
                <RadioGroup
                    v-model="form.radioBtn.rolloverEndStop"
                    :options="radioBtnOptions.rolloverEndStop"
                    :disable="false"/>
            </SettingItem>
            <SettingItem label="バックライト">
                <ToggleSwitch v-model="form.toggle.backlight" :disable="false" />
                <RadioGroup
                    v-model="form.radioBtn.backlight"
                    :options="radioBtnOptions.backlight"
                    :disable="!form.toggle.backlight"/>
            </SettingItem>
            <SettingItem label="バックライト点灯時間">
            <SelectBox
                :disabled="false"
                :options="selectboxOptions.backlightTimer"
                :defaultValue="String(form.selectbox.backlightTimer)"
                @update="handleSelect"/>
            </SettingItem>
            <SettingItem label="モード・リセット・タイマー">
                <ToggleSwitch v-model="form.toggle.modeResetTimer" :disable="false" />
                <RangeSlider
                    :inputValue="form.range.modeResetTimerValue"
                    @update:inputValue="form.range.modeResetTimerValue = $event"
                    :disable="!form.toggle.modeResetTimer"
                    :minLimit="BC.OPTIONAL_FEATURES.DISPLAY.MODE_RESET_TIMER_VALUE.MIN"
                    :maxLimit="BC.OPTIONAL_FEATURES.DISPLAY.MODE_RESET_TIMER_VALUE.MAX"
                    unit="[秒]"/>
            </SettingItem>
            <SettingItem label="縦倍角メニュー表示">
                <ToggleSwitch v-model="form.toggle.doubleHeightMenuDisplay" :disable="false" />
            </SettingItem>
        </SettingGroup>

        <SettingGroup title="LED">
            <SettingItem label="受信時 LED 点灯">
                <ToggleSwitch v-model="form.toggle.busyLed" :disable="false" />
            </SettingItem>
            <SettingItem label="送信時 LED 点灯">
                <ToggleSwitch v-model="form.toggle.transmitLed" :disable="false" />
            </SettingItem>
        </SettingGroup>
    </div>
</template>
